import * as Avatar from '@radix-ui/react-avatar';
import classNames from 'classnames';

import { ChatType } from '@anyx/common-graphql';
import { AvatarIcon } from '@anyx/shared-icons';


import { CrmChannelIcon } from '../crm-channel-icon';
/**
 * xs - 32px | sm - 40px | md - 48px |lg -56px | xl - 64px
 */
type ChatAvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface ChatAvatarProps {
  sns?: ChatType;
  resolved?: boolean;
  src?: string;
  alt?: string;
  size?: ChatAvatarSize;
}

export const ChatAvatar = ({ sns, resolved = true, src, alt, size = 'md' }: ChatAvatarProps) => {
  return (
    <Avatar.Root asChild data-chromatic="ignore">
      <div
        className={classNames('rounded-full select-none', {
          'bg-warning': !resolved,
          'h-8 w-8 p-0.5': size === 'xs',
          'h-10 w-10 p-0.5': size === 'sm',
          'h-12 w-12 p-0.5': size === 'md',
          'h-14 w-14 p-0.5': size === 'lg',
          'h-16 w-16 p-0.5': size === 'xl',
        })}
      >
        <div className="relative block h-full w-full rounded-full bg-white p-0.5">
          <div
            className={classNames('bg-status-blue rounded-full', {
              'h-6 w-6': size === 'xs',
              'h-8 w-8': size === 'sm',
              'h-10 w-10': size === 'md',
              'h-12 w-12': size === 'lg',
              'h-14 w-14': size === 'xl',
            })}
          >
            <Avatar.Image className="h-full w-full rounded-full object-cover" src={src} alt={alt} />

            <Avatar.Fallback
              delayMs={1000}
              className="flex h-full w-full items-center justify-center"
            >
              <AvatarIcon
                className={classNames('[&>path]:fill-blue-6 h-1/2 w-1/2 [&>path]:opacity-30')}
              />
            </Avatar.Fallback>
          </div>

          {sns && (
            <CrmChannelIcon
              channel={sns}
              type="circleFa"
              className={classNames('absolute', {
                '-right-1 bottom-0 h-3 w-3': size === 'xs',
                '-right-1 -bottom-0.5 h-5 w-5': size === 'sm',
                '-right-0.5 -bottom-0.5 h-5 w-5': size === 'md',
                '-right-1 -bottom-1 h-6 w-6': size === 'lg',
                '-right-1 -bottom-1 h-7 w-7': size === 'xl',
              })}
            />
          )}
        </div>
      </div>
    </Avatar.Root>
  );
};
